// extracted by css-extract-rspack-plugin
export default {"cls1":"PodcastLibraryCarouselAd-cls1_VNT","cls2":"PodcastLibraryCarouselAd-cls2_aey PodcastLibraryCarouselAd-cls1_VNT"};